<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="(displayEmployee.EmployeeId ? 'Edit Employee: ' + displayEmployee.EmployeeNumber : 'New Employee') + ' :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/employees`">
                            <i class="fa fa-group"></i> Employees
                        </router-link>
                    </li>
                    <template v-if="EmployeeId">
                        <li class="breadcrumb-item font-weight-light">
                            <router-link :to="`/employees/view/${EmployeeId}`">
                                {{ displayEmployee.FirstName }} {{ displayEmployee.LastName }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active">Edit</li>
                    </template>
                    <template v-else>
                        <li class="breadcrumb-item active">New Employee</li>
                    </template>
                    <li class="ml-3">
                        <button type="button" class="btn btn-sm btn-success" v-on:click="saveEmployee(this)" :disabled="saving">
                            <span v-if="EmployeeId">Update</span>
                            <span v-else>Create</span>
                            Employee
                        </button>
                    </li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-lg-8">
                    <div class="card">
                        <div class="card-header">Employee Details</div>
                        <div class="card-body">
                            <employee-form
                                :employee="employee"
                                :divisions="divisions"
                                :drivers="drivers"
                                :required_fields="required_fields"
                                ref="employeeForm"
                                :showCreateSubcontractor="true"
                                @employeeSaved="employeeSaved"
                                @employeeFailed="employeeFailed"
                                @employeeFormErrors="setErrors"></employee-form>
                        </div>
                    </div>

                    <div v-if="sections" class="mt-4">
                        <incident-sections-builder :sections="sections" :initialValues="custom_fields" @customFieldsChanged="setCustomFields" :errors="errors"></incident-sections-builder>
                    </div>
                </div>

                <div class="col-lg-4 mt-lg-0 mt-4">
                    <div class="card">
                        <div class="card-header">Add to User List</div>
                        <div class="card-body">
                            <b-form-checkbox v-model="is_linked_to_user" :value="true" :unchecked-value="false" plain class="mb-2"> Add to User List</b-form-checkbox>

                            <div v-if="is_linked_to_user">
                                <b-form-checkbox v-model="create_new_user" :value="true" :unchecked-value="false" plain class="mb-2"> Create a New User</b-form-checkbox>

                                <label>Or Select Existing User:</label>
                                <user-select ref="empUserSelect" :selectedValues="userValues" @vuselected="onUserSelect" />

                                <div class="alert alert-danger mt-2" v-if="errors.is_linked_to_user">
                                    {{ errors.is_linked_to_user }}
                                </div>
                            </div>
                            <div class="alert alert-warning mt-4">
                                This will add the employee to the dropdown user list on Corrective Actions, Incidents, and more. Any place where users are selected will list this person as an option
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <button type="button" class="btn btn-success mt-4" v-on:click="saveEmployee()" :disabled="saving">
                <span v-if="EmployeeId">Update</span>
                <span v-else>Create</span>
                Employee
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                saving: false,
                is_linked_to_user: false,
                create_new_user: false,
                EmployeeId: this.$route.params.id,
                employee: {
                    division_id: null,
                    subcontractor_id: null,
                },
                displayEmployee: {},
                user: null,
                errors: {},
                divisions: [],
                drivers: [],
                required_fields: [],
                sections: null,
                custom_fields: {},
            }
        },

        watch: {

            create_new_user(newVal, oldVal){
                //IF true, clear the user
                if(newVal === true)
                {
                    //Clear it
                    this.user = null;
                    this.employee.UserId = null;
                    this.$refs.empUserSelect.reset();
                }
            }
        },

        computed: {

            userValues(){
                //check for null
                if(!this.user)
                {
                    return {};
                }

                //SEnd the payload
                return {UserId: this.user.UserId, FirstName: this.user.FirstName, LastName: this.user.LastName, email: this.user.email};
            },

            customFieldFileTypes(){
                //Loop and build
                var fields = [];

                //Check for null
                if(this.sections == null)
                {
                    return fields;
                }

                //Loop through Sections
                for (var i = this.sections.length - 1; i >= 0; i--)
                {
                    //Loop through the fields
                    for (var j = this.sections[i].fields.length - 1; j >= 0; j--)
                    {
                        //Check the type
                        if(this.sections[i].fields[j].type == 'File')
                        {
                            fields.push(this.sections[i].fields[j]);
                        }
                    }
                }

                //Send it
                return fields;
            },
        },

        methods: {

            getEmployee() {
                //Get the data
                this.$http
                    .get('employees/edit' + (this.EmployeeId ? '/' + this.EmployeeId : ''))
                    .then(response => {
                        //Set all the data
                        this.employee = response.data.employee;
                        this.divisions = response.data.divisions;
                        this.drivers = response.data.drivers;
                        this.displayEmployee = Object.assign({}, this.employee);
                        this.user = response.data.user;
                        this.is_linked_to_user = this.user ? true : false;
                        this.required_fields = response.data.required_fields;

                        //Custom Fields
                        this.sections = response.data.sections;
                        this.custom_fields = response.data.custom_fields;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            saveEmployee() {
                //Reset errors
                this.errors = {};

                //Basic Validation
                if(this.is_linked_to_user && !this.create_new_user && !this.user)
                {
                    //setu
                    var message = 'Select an Existing User or check Create a New User to add Employee to user list.';

                    //Alert the user
                    this.$toastr.error(message);

                    //Push some errors?
                    this.errors['is_linked_to_user'] = message;

                    //Stop
                    return;
                }

               //Call the child helper
               this.saving = true;

               //Setup
               var payload = {
                    create_new_user: this.create_new_user,
                    UserId: this.user && this.user.UserId ? this.user.UserId : null,
                    custom_fields: this.custom_fields,
                    include_custom_fields: true,
               };

               //Build the custom field Files
               var customFieldFiles = {};

               //Loop and Build
               for (var i = this.customFieldFileTypes.length - 1; i >= 0; i--)
               {
                   //Push onto the fields
                   if(this.custom_fields[this.customFieldFileTypes[i].id])
                   {
                       //Set the field type
                       customFieldFiles['custom_field_file_'+this.customFieldFileTypes[i].id] = this.custom_fields[this.customFieldFileTypes[i].id];

                       //Delete from the incident
                       //delete this.incident.custom_fields[this.customFieldFileTypes[i].id];
                   }
               }

               //Do it
               this.$refs.employeeForm.saveEmployee(payload, customFieldFiles);
            },

            employeeSaved: function(employee){
                this.saving = false;

                //Return to main list?
                this.$router.push('/employees/view/' + employee.EmployeeId);
            },

            employeeFailed: function(employee) {
                this.saving = false;
            },

            onUserSelect(user){
                //Check for NULL
                if (user == null)
                {
                    this.user = null;
                    this.employee.UserId = null;
                    return;
                }

                //Set some values
                this.user = user;
                this.employee.UserId = user.UserId;
            },

            setCustomFields(fields){
                //Set it
                this.custom_fields = fields;
            },

            setErrors(errors){
                this.errors = errors;
            },
        },

        mounted() {
            //Get the employee
            this.getEmployee();
        }
    }
</script>
